import { OrderExecutionTermsOrderType } from 'api/types/entity/account/order';
import { OrderParams } from 'api/types/params';
import { lodash } from 'helpers';

import { DEFAULT_NOMINAL_VALUE } from '../constants';
import { OrderDetailsFormType, OrderFormType } from '../forms/orderForm/type';

const parseDetails = (details: OrderDetailsFormType) => ({
  accountNumber: details.accountNumber,
  brokerName: {
    referenceRecordId: details.brokerName.record?.id || undefined,
    value: details.brokerName.label,
  },
  custodianOrganization: {
    referenceRecordId: details.custodianOrganization.record?.id || undefined,
    value: details.custodianOrganization.label,
  },
  accountOwnerName: details.accountOwnerName,
  custodianOrganizationCode: details.custodianOrganizationCode ?? undefined,
});

export const parseOrderParams = (values: OrderFormType): OrderParams => ({
  executionTerms: {
    additionalNotes: values.executionTerms?.additionalNotes!,
    orderType: values.executionTerms?.orderType?.value ?? undefined,
    yield: values.executionTerms?.yield ?? undefined,
    operationKind: values.executionTerms?.operationKind?.value ?? undefined,
    operationPurpose: values.executionTerms?.operationPurpose ?? undefined,
  },
  endDate: values.endDate!,
  financialInstrument: {
    nominalValue:
      values.financialInstrument?.nominalValue ??
      DEFAULT_NOMINAL_VALUE.toString(),
    issuer: values.financialInstrument?.issuer ?? undefined,
    isin: {
      value: values.financialInstrument?.isin.label,
      referenceRecordId:
        values.financialInstrument?.isin.record?.id || undefined,
    },
    securityType: values.financialInstrument?.securityType ?? undefined,
  },
  transactionVolume: values.transactionVolume
    ? {
        currency: values.transactionVolume?.currency.label!,
        quantity: Number(values.transactionVolume?.quantity!),
        transactionAmount:
          values.executionTerms?.orderType?.value ===
          OrderExecutionTermsOrderType.Market
            ? undefined
            : values.transactionVolume?.transactionAmount!,
        unitPrice:
          values.executionTerms?.orderType?.value ===
          OrderExecutionTermsOrderType.Market
            ? undefined
            : values.transactionVolume?.unitPrice!,
      }
    : undefined,
  transferVolume: values.transferVolume
    ? {
        currency: values.transferVolume.currency?.label!,
        quantity: Number(values.transferVolume?.quantity!),
        transactionAmount: values.transferVolume?.transactionAmount!,
        unitPrice: values.transferVolume?.unitPrice!,
      }
    : undefined,

  recipientDetails: values.recipientDetails
    ? parseDetails(values.recipientDetails)
    : undefined,

  senderDetails: values.senderDetails
    ? parseDetails(values.senderDetails)
    : undefined,

  confirmationDocument: values.confirmationDocument
    ? {
        contractDate: values.confirmationDocument.contractDate ?? undefined,
        contractNumber: values.confirmationDocument.contractNumber ?? undefined,
        fileIds: lodash.compact(
          values.confirmationDocument.files?.map((file) => file.id)
        ),
      }
    : undefined,

  additionalParameters: values.additionalParameters
    ? {
        settlementDate: values.additionalParameters.settlementDate ?? undefined,
        transactionDate:
          values.additionalParameters.transactionDate ?? undefined,
      }
    : undefined,
});
